export default __webpack_public_path__ + "static/media/Hambergur_icon.e05c4f0a.svg";